import { env } from "@/lib/env/client";

declare global {
  interface Window {
    uetq?: { push: (...args: unknown[]) => void };
  }
}

/**
 * Client-side Bing UET conversion tracking for outbound clicks.
 *
 * Pushes an "outbound_click" event to the Bing UET queue when
 * NEXT_PUBLIC_BING_UET_TAG_ID is configured. No-ops silently when absent
 * so non-Bing deployments are unaffected.
 */
export function fireBingOutboundConversion(): void {
  if (!env.NEXT_PUBLIC_BING_UET_TAG_ID) return;
  window.uetq?.push("event", "outbound_click", {});
}
